import { render } from "./MenuButton.vue?vue&type=template&id=59f16b43"
import script from "./MenuButton.vue?vue&type=script&lang=js"
export * from "./MenuButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/GenericComponents/MenuButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59f16b43"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59f16b43', __exports__)) {
    api.reload('59f16b43', __exports__)
  }
  
  module.hot.accept("./MenuButton.vue?vue&type=template&id=59f16b43", () => {
    api.rerender('59f16b43', render)
  })

}


export default __exports__